<template lang="pug">
  div
    .main
      .config-form-wrapper.row
        .config-form.col-md-6.col-lg-5.col-xl-4
          h2.title {{title}}
          br
          <el-input v-model="name" placeholder="此处将显示授权码" auto-complete="off" style="width:300px;" :readonly="true"></el-input>
          <el-button type="primary" style="float:center;margin-top:30px" @click="getRoleProof()">立即获取</el-button>
          <!-- <div id="contains" v-html="containsHtml" style="background:#ccc;height:300px;width:300px;white-space: pre-wrap;line-height:23px;border-radius:5px"></div> -->
          <el-input type="textarea" v-model="name" placeholder="此处将显示您本次已获取的授权码" auto-complete="off" style="width:300px;margin-top:20px;line-height:23px;" :readonly="true" :rows="8"></el-input>
</template>

<script>
import axios from 'axios'
import { expire } from '@/utils/auth'
export default {
  data () {
    return {
      hasColumns: false,
      count: 0,
      title: '授权码生成',
      name: '',
      names: '',
      formValues: {},
      columns: {},
      containsHtml: ''
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  methods: {
    getRoleProof () {
      let url = 'base/location/register/getRegister'
      axios.get(url).then(res => {
        if (res.status === 200) {
          if (this.name !== '') {
            let html = this.containsHtml
            html += (res.data + '<br>')
            this.containsHtml = html
          }
          this.name = res.data
          console.log(res.data)
          const h = this.$createElement
          this.$message({
            message: h('p', null, [
              h('span', null, '恭喜您生成了一条授权码'),
              h('i', { style: 'color: teal' }, '一个授权码仅可使用一次')
            ])
          })
        } else {
          this.$message({
            message: '系统错误，请联系管理员',
            showClose: true,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
.config-form-wrapper
  margin: 40px
.config-form
  margin: 0 auto
  .title
    padding-left: 5px
</style>



// WEBPACK FOOTER //
// shouquanma.vue?27516f5a